import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Box, useMediaQuery, useTheme } from '@mui/material';
import { MdMenu } from 'react-icons/md';
import ParameterScreen from '../screens/ParameterScreen';

const Header: React.FC = () => {
  const [isParameterOpen, setIsParameterOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const handleSettings = () => {
    setIsParameterOpen(true);
  };

  const handleCloseParameter = () => {
    setIsParameterOpen(false);
  };

  // On desktop, the sidebar handles logo + settings
  if (isDesktop) {
    return null;
  }

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid #ECE4D3',
        }}
      >
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            minHeight: '70px',
            px: '15px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
            }}
          >
            <Box
              component="img"
              src="/logo-betraveling.svg"
              alt="BeTravel"
              sx={{
                width: 42,
                height: 42,
                objectFit: 'contain',
                borderRadius: 1,
                boxShadow: '0 4px 12px rgba(216, 157, 47, 0.30)',
              }}
            />
            <Box
              sx={{
                fontFamily: "'Fraunces', serif",
                fontSize: 20,
                fontWeight: 600,
                color: '#1A1A1A',
                letterSpacing: '-0.01em',
              }}
            >
              Be<Box component="span" sx={{ color: '#D89D2F' }}>Travel</Box>
            </Box>
          </Box>
          <IconButton onClick={handleSettings} sx={{ color: '#1A1A1A' }}>
            <MdMenu size={36} />
          </IconButton>
        </Toolbar>
      </AppBar>

      <ParameterScreen open={isParameterOpen} onClose={handleCloseParameter} />
    </>
  );
};

export default Header;
